import * as types from "../mutationTypes"
import User from "../../services/user"
let state = {
    email: null,
    role: null,
    id: null,
    currentUser: null,
    users: [],
    archivedUsers: [],
    headers: [
        { text: 'Username', value: 'user.email' },
        { text: 'First Name', value: 'user.firstName' },
        { text: 'Last Name', value: 'user.lastName' },
        { text: 'Phone', value: 'user.phoneNumber' },
        { text: 'Actions', value: 'action', sortable: false }
    ],
    error: null
}
const getters = {
    currentUser (state) {
        return state.currentUser
    },
    currentRole (state) {
        return state.role
    },
    users (state) {
        let newArray = new Array(state.users.length);
        for (const i in state.users){
            const user = state.users[i];
            newArray[i] = {
                user: user,
            }
        }
        return newArray
    },
    archived (state) {
        let newArray = new Array(state.archivedUsers.length);
        for (const i in state.archivedUsers){
            const user = state.archivedUsers[i];
            newArray[i] = {
                user: user,
            }
        }
        return newArray
    },
    headers (state) {
        return state.headers
    },
    error (state) {
        return state.error
    }
}
const actions = {
    async loadAllUsers ({ commit, dispatch }) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.get()
            if (res) {
                commit(types.REQUEST_USER_LIST_SUCCESS, res.data)
            }
        } catch (err) {
            commit(types.REQUEST_USER_LIST_ERROR, 'Error loading user list' + err.message)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },
    async loadUser ({ commit, dispatch }, id) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.getById(id)
            if (res) {
                commit(types.UPDATE_USER, res.data)
            }
        } catch (err) {
            commit(types.REQUEST_USER_ERROR, err.message)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

    async loadArchivedUsers ({ commit, dispatch }) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.getArchived()
            if (res) {
                commit(types.REQUEST_ARCHIVE_USER_LIST_SUCCESS, res.data)
            }
        } catch (err) {
            commit(types.REQUEST_USER_LIST_ERROR, 'Error loading archived user list')
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

    async updateUser ({ commit, dispatch }, user) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.update(user)
            if (res) {
                commit(types.UPDATE_USER, user)
                dispatch('loadAllUsers')
                dispatch('loadArchivedUsers')
            }
        } catch (err) {
            commit(types.UPDATE_USER_ERROR, 'Error updating user ' + err.message)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

    async deleteUser ({ commit, dispatch }, user) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.delete(user.id)
            if (res) {
                commit(types.DELETE_USER, res.data)
                dispatch('loadArchivedUsers')
            }
        } catch (err) {
            commit(types.REQUEST_USER_ERROR, `Error deleting user ${err}`)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

    async archiveUser ({ commit, dispatch }, user) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.archive(user.id)
            if (res) {
                commit(types.ARCHIVE_USER_SUCCESS, res.data)
                dispatch('loadAllUsers')
            }
        } catch (err) {
            commit(types.ARCHIVE_USER_ERROR, 'Error archiving user')
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

    async restoreUser ({ commit, dispatch }, user) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.restore(user.id)
            if (res) {
                commit(types.RESTORE_USER_SUCCESS, res.data)
                dispatch('loadArchivedUsers')
            }
        } catch (err) {
            commit(types.RESTORE_USER_ERROR, 'Error restoring user')
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

    async createUser ({ commit, dispatch }, newUser) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            let res = await User.create(newUser)
            if (res) {
                commit(types.CREATE_USER, newUser)
                dispatch('loadAllUsers')
            }
        } catch (err) {
            commit(types.CREATE_USER_ERROR, 'Error creating user')
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },
    async setCurrentUser ({ commit }, user) {
        let currentUser = await User.getById(user.id)
        currentUser.data.roles = user.roles
        commit(types.SET_CURRENT_USER, currentUser.data)
    },

    async clear ({ commit }) {
        commit(types.CLEAR_USER)
    }
}
const mutations = {
    [types.SET_CURRENT_USER] (state, user) {
        state.currentUser = user
        state.email = user.email
        state.id = user.id
        state.role = user.roles[0]
    },
    [types.REQUEST_USER_ERROR] (state, message) {
        state.error = message
    },
    [types.UPDATE_USER] (state, user) {
        state.userToUpdate = user
        state.error = null
    },
    [types.CREATE_USER] (state) {
        state.error = null
    },
    [types.CREATE_USER_ERROR] (state, message) {
        state.email = null
        state.password = null
        state.role = null
        state.error = message
    },

    [types.CLEAR_USER] (state) {
        state.email = null
        state.id = null
        state.role = null
        state.error = null
        state.currentUser = null
    },

    [types.DELETE_USER] (state) {
        state.user = null
        state.error = null
    },

    [types.ARCHIVE_USER_SUCCESS] (state) {
        state.error = null
    },

    [types.ARCHIVE_USER_ERROR] (state, message) {
        state.error = message
    },

    [types.RESTORE_USER_SUCCESS] (state) {
        state.error = null
    },

    [types.RESTORE_USER_ERROR] (state, message) {
        state.error = message
    },

    [types.REQUEST_USER_LIST_SUCCESS] (state, users) {
        state.users = users
        state.error = null
    },

    [types.REQUEST_ARCHIVE_USER_LIST_SUCCESS] (state, archivedUsers) {
        state.archivedUsers = archivedUsers
        state.error = null
    },

    [types.REQUEST_USER_LIST_ERROR] (state, message) {
        state.users = []
        state.archivedUsers = []
        state.error = message
    },
    [types.UPDATE_USER_ERROR] (state, message) {
        state.userToUpdate = null
        state.error = message
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
